/**
 * ============================================================================
 * Auth 模块 - 常量定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义枚举标签映射（中文显示）
 * 
 * 📖 对应后端：
 * - Model: backend/app/Models/User.php (静态属性)
 * 
 * ⚠️ 注意事项：
 * - 标签对象命名：{MODULE}_{ENUM}_LABELS（全大写）
 * - 使用 `as const` 保证类型推断
 * - 枚举标签的 key 必须与 enums.ts 中的枚举值对应
 * 
 * 🔄 更新时机：
 * - enums.ts 新增枚举值时（同步新增标签）
 * - 中文标签需要修改时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Models/User.php
 * 2. 检查本文件的 LABELS 对象是否包含所有映射
 * 3. 检查中文标签是否合理
 * 
 * @module types/auth/constants
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

import { DeviceType } from './enums'

/**
 * ⚠️ USER_STATUS_LABELS 已移至 types/user/constants.ts
 * 
 * 请使用：
 * ```typescript
 * import { USER_STATUS_LABELS } from '../user'
 * ```
 * 
 * @deprecated 请从 @bayes-mes/shared/types/user 导入
 */
// USER_STATUS_LABELS 已移至 types/user/constants.ts

/**
 * 设备类型标签映射
 */
export const DEVICE_TYPE_LABELS = {
  [DeviceType.WEB]: 'Web浏览器',
  [DeviceType.IOS]: 'iOS应用',
  [DeviceType.ANDROID]: 'Android应用',
  [DeviceType.MINI_PROGRAM]: '小程序',
  [DeviceType.OTHER]: '其他',
} as const

